import { Subscription } from 'rxjs';
import { getError } from './../store/selectors/package-visualizer.selectors';
import { Component, OnInit, Inject } from '@angular/core';
import {OverlayService} from '../../shared/services/overlay.service';
import { Store, select } from '@ngrx/store';
import { SetSelectedCatalogObjects, GetPackageSummary, SetSearchText, SearchAndFilterPackageSummary, SetError } from '../store/actions/package-visualizer.actions';
import { Observable } from 'rxjs';
import { getSelectedObjects, getIsLoading, getNavigation } from '../store/selectors/package-visualizer.selectors';
import { PACKAGE_VISUALIZER_DATA } from '../core/contracts/package-visualizer.data';
import { IAppState } from 'app/IAppState';

@Component({
  selector: 'biz-package-visualizer',
  templateUrl: './package-visualizer.component.html',
  styleUrls: ['./package-visualizer.component.scss']
})
export class PackageVisualizerComponent implements OnInit {
  public isSearchMode = false;
  public catalogObjectList$: Observable<
    Array<{ type: string; objectList: ICatalogObject[] }>
  >;
  public isLoadingList$: Observable<boolean>;
  public navigation$: Observable<IPackageNavigation[]>;
  public hasErrorSubscription: Subscription;

  public _packageData: {
    packageId: Guid;
    packageName: string;
  };

  constructor(
    @Inject(PACKAGE_VISUALIZER_DATA) packageData: any,
    private _store: Store<IAppState>,
    private _overlayService: OverlayService
  ) {
    this._packageData = packageData;
    this.catalogObjectList$ = this._store.pipe(select(getSelectedObjects));
    this.isLoadingList$ = this._store.pipe(select(getIsLoading));
    this.navigation$ = this._store.pipe(select(getNavigation));

    this.hasErrorSubscription = this._store.pipe(select(getError)).subscribe(value => {
      if (value) {
        this._store.dispatch(new SetError(false));
        this.close();
      }
    });
  }

  ngOnInit() {
    this._store.dispatch(new GetPackageSummary(this._packageData));
  }

  public setSearchMode(event: boolean) {
    if (!event) {
      this._store.dispatch(new SetSelectedCatalogObjects());
    }

    this.isSearchMode = event;
  }

  public close() {
    this._overlayService.hide();
  }

  public searchText(textToSearch: string) {
    this._store.dispatch(new SetSearchText(textToSearch));
    this._store.dispatch(new SearchAndFilterPackageSummary());
  }

  selectCatalogObject(catalogObjectId: string) {
    this._store.dispatch(new SetSelectedCatalogObjects(catalogObjectId));
  }
}
